import { zeroAgNumberEditor, zeroAgSelectEditor, zeroAgStringEditor, zeroAgMultiselectEditor, zeroAgDateEditor, } from './cell-editors';
import { zeroAgEditableRenderer, zeroAgActionRenderer, zeroAgActionsMenuRenderer, zeroAgBooleanRenderer, zeroAgSelectRenderer, zeroAgTextRenderer, } from './cell-renderers';
import { zeroGridPro } from './grid-pro';
export const zeroGridComponents = {
    zeroAgEditableRenderer,
    zeroAgActionRenderer,
    zeroAgActionsMenuRenderer,
    zeroAgBooleanRenderer,
    zeroAgTextRenderer,
    zeroAgSelectRenderer,
    zeroAgDateEditor,
    zeroAgMultiselectEditor,
    zeroAgSelectEditor,
    zeroAgNumberEditor,
    zeroAgStringEditor,
    zeroGridPro,
    register(container, ...rest) {
        if (!container) {
            // preserve backward compatibility with code that loops through
            // the values of this object and calls them as funcs with no args
            return;
        }
        for (const key in this) {
            if (key === 'register') {
                continue;
            }
            this[key]().register(container, ...rest);
        }
    },
};
